export class PremierDernierJoursSemaine {
	premierJourSemaine: Date;
	dernierJoursSemaine: Date;

	constructor(premierJourSemaine: Date, dernierJoursSemaine: Date) {
		this.premierJourSemaine = premierJourSemaine;
		this.dernierJoursSemaine = dernierJoursSemaine;
	}
}
